import React, { Component } from "react"
import PropTypes from "prop-types"
import Helmet from 'react-helmet';
import { StaticQuery, graphql } from 'gatsby';

import "../static/css/font-awesome.min.css"
import "../static/css/animate.css"
import "../static/css/icofonts.css"
import "../static/css/bootstrap.min.css"
import "../static/css/owlcarousel.min.css"
import "../static/css/magnific-popup.css"
import "../static/css/style.css"
import "../static/css/responsive.css"

import Header from  "./header"
import Footer from "./footer"
import ContactUs from "./contact-us"

import ImportScripts from "./importScripts"
const Layout = (props) => {
    const { children } = props;
    return (
      <StaticQuery
        query={graphql`
      query SiteTitleQuery {
        site {
          siteMetadata {
            title,
            description,
            siteUrl,
            logo,
            author,
            type,
          }
        }
      }
    `}
        render={(data) => {
          const {
            title,
            description,
            siteUrl,
            type,
            author,
            logo,
          } = data.site.siteMetadata;
          return (
              <React.Fragment>
                 <Helmet
                  title={title}

                  meta={[
                    { name: 'google-site-verification', content: '' },
                    { name: 'description', content: description },
                    { name: 'author', content: author },
                    { property: 'og:url', content: siteUrl },
                    { property: 'og:image', content: logo },
                    { property: 'og:title', content: title },
                    { property: 'og:type', content: type },
                    { property: 'og:description', content: description },
                  ]}
                  link={[
                  
                    { rel: 'canonical', href: siteUrl },
                  ]}
                >
                  <html dir="ltr" lang="en" />
                </Helmet>
                
                <main>
                  <Header />
                {children}
                <ContactUs />
                <Footer />
                </main>
                
                <ImportScripts />
              </React.Fragment>
             );
            }}
          />
        );
      }
    
  
  Layout.propTypes = {
    children: PropTypes.node.isRequired,
  };
  
  export default Layout;
  